/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class AdvancedSearchController {
   $scope: any
   advancedSearch: AdvancedSearchService
   appState: AppStateService
   config: ConfigService
   datepicker: DatepickerService
   translationService: TranslationService
   searchScopeService: SearchScopeService
   constructor($scope: any, advancedSearch: AdvancedSearchService, config: ConfigService, translationService: TranslationService, appState: AppStateService, datepicker: DatepickerService, searchScopeService: SearchScopeService) {
      this.$scope = $scope
      this.advancedSearch = advancedSearch
      this.config = config
      this.translationService = translationService
      this.appState = appState
      this.datepicker = datepicker
      this.searchScopeService = searchScopeService
      this.$scope.advanced = this.advancedSearch.scope
      this.$scope.advanced.config = this.config.data.advancedSearch
      this.$scope.advanced.addCustomField = this.advancedSearch.addCustomField
      this.$scope.advanced.removeCustomField = this.advancedSearch.removeCustomField
      this.$scope.advanced.removeFacets = this.advancedSearch.removeFacets
      this.$scope.advanced.selectionsOnChg = this.advancedSearch.selectionsOnChange
      this.$scope.advanced.getContentTypes = this.advancedSearch.getContentTypes
      this.$scope.advanced.getDisciplines = this.advancedSearch.getDisciplines
      this.$scope.advanced.getLanguages = this.advancedSearch.getLanguages
      this.$scope.advanced.readableSelectedContentTypes = this.translationService.translations.ANY_TYPE
      this.$scope.advanced.readableSelectedDisciplines = this.translationService.translations.ANY_TYPE
      this.$scope.advanced.readableSelectedLanguages = this.translationService.translations.ANY_TYPE
      this.$scope.advanced.hasMaxCustomRows = this.advancedSearch.hasMaxCustomRows
      this.$scope.advanced.syncWithState = this.advancedSearch.syncWithState
      this.$scope.advanced.updateSearchScope = this.advancedSearch.updateSearchScope
      this.$scope.i18n = this.translationService
    
      // update the height to make sure we're not pushing the submit bottom out of view
      const facetChangeHandler = (newValue: any) => {
         const returnValue = []
         // way to make sure the adv search dialog footer is always in view
         // @ts-expect-error TS(2345) FIXME: Argument of type 'number | undefined' is not assig... Remove this comment to see the full error message
         const facetContainerHeight = parseInt($('.clearRefinementsContainer').height()) 
         if (isNaN(facetContainerHeight)) {
            return document.documentElement.style.setProperty('--advanced-selected-facets-height', '0px')
         } else {
            return document.documentElement.style.setProperty('--advanced-selected-facets-height', facetContainerHeight + 'px')
         }
      }
    
      this.$scope.$watch('advanced.selectedSummary', facetChangeHandler, true)
   }
}

AdvancedSearchController.$inject = ['$scope', 'advancedSearchService', 'configService', 'translationService', 'appStateService', 'datepickerService', 'searchScopeService']

angular.module('summonApp.controllers')
   .controller('AdvancedSearchCtrl', AdvancedSearchController)
